import { render, staticRenderFns } from "./SingleCurrency.vue?vue&type=template&id=69245f54&"
import script from "./SingleCurrency.vue?vue&type=script&lang=js&"
export * from "./SingleCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports